import Endpoints from 'constants/Endpoints';
import {RestRequestBLOB, RestRequestGET, RestRequestPOST} from 'libs/RestRequest';
import {clearResource, setResource} from 'redux/actions'
import reduxStore from 'redux/store'
import applySearchParams from "libs/applySearchParams";

const RESOURCE_ID_RFX_OFFER_LIST = 'rfxOfferList';
const RESOURCE_ID_RFX_OFFERS_ACTIONS = 'rfxOffersActions';
const RESOURCE_ID_RFX_OFFER_DECRYPTION_STATUS = 'rfxOfferDecryptionStatus';
const RESOURCE_ID_RFX_OFFER_PUBLIC_SESSION_STATUS = 'rfxOfferPublicSessionStatus';
const RESOURCE_ID_RFX_PUBLIC_SESSION_ONLINE_STATUS = 'rfxOfferPublicSessionOnlineStatus';

const clearResources = (resource) => {
    reduxStore.dispatch(clearResource(resource));
}
const getOffers = async (roundId, pagination, search) => {
    const params = {
        ...pagination
    }
    applySearchParams(search, params)

    try {
        const res = await RestRequestGET(Endpoints.RFX_OFFERS_LIST(roundId), {params});

        if (pagination.page > 1) {
            const state = reduxStore.getState();
            if (state.resources && state.resources[RESOURCE_ID_RFX_OFFER_LIST]) {
                const res2 = {
                    ...res,
                    items: [...state.resources[RESOURCE_ID_RFX_OFFER_LIST].items, ...res.items],
                }
                reduxStore.dispatch(setResource(RESOURCE_ID_RFX_OFFER_LIST, res2));
                return;
            }
        }
        reduxStore.dispatch(setResource(RESOURCE_ID_RFX_OFFER_LIST, res));

    } catch (error) {
    }
}
const getAvailableActions = async (roundId) => {
    const res = await RestRequestGET(Endpoints.RFX_OFFERS_ACTIONS(roundId));
    reduxStore.dispatch(setResource(RESOURCE_ID_RFX_OFFERS_ACTIONS, res.actions));
}

const getAdditionalRoundsOffers = async (roundId, supplierId) => {

    const res = await RestRequestGET(Endpoints.RFX_OFFERS_ADDITIONAL_ROUND_OFFERS(roundId, supplierId));
    _doAdditionalRoundsOffers(roundId, supplierId, res);
}
const clearAdditionalRoundsOffers = async (roundId, supplierId) => {
    _doAdditionalRoundsOffers(roundId, supplierId, undefined);
}
const _doAdditionalRoundsOffers = (roundId, supplierId, additionalOffers) => {

    const {resources} = reduxStore.getState();
    if (resources[RESOURCE_ID_RFX_OFFER_LIST]) {
        const curList = resources[RESOURCE_ID_RFX_OFFER_LIST];
        const res2 = {
            ...curList,
            items: curList.items.map(item => item.id !== supplierId ? item : {...item, additionalOffers}),
        }
        reduxStore.dispatch(setResource(RESOURCE_ID_RFX_OFFER_LIST, res2));
    }
}




const sendIvniteToOffers = async (roundId, emailsTab) => {
    const emails = {
        emails: emailsTab
    }
    const resp = await RestRequestPOST(Endpoints.RFX_OFFERS_SEND_INVITE(roundId), emails);
    return resp;
}

const getOffersDecryptionStatus = async (roundId) => {
    const resp = await RestRequestGET(Endpoints.RFX_OFFERS_DECRYPTION_STATUS(roundId));
    reduxStore.dispatch(setResource(RESOURCE_ID_RFX_OFFER_DECRYPTION_STATUS, resp));
    return resp;
}

const getOffersDecryptionProgress = async (roundId) => {
    return await RestRequestGET(Endpoints.RFX_OFFERS_DECRYPTION_PROGRESS(roundId));
}

const startOffersDecryptionProcess = async (roundId) => {
    return await RestRequestPOST(Endpoints.RFX_OFFERS_DECRYPTION_START(roundId));
}

const getOffersPublicSessionStatus = async (roundId) => {
    const resp = await RestRequestGET(Endpoints.RFX_OFFERS_PUBLIC_SESSION_STATUS(roundId));
    reduxStore.dispatch(setResource(RESOURCE_ID_RFX_OFFER_PUBLIC_SESSION_STATUS, resp));
    return resp;
}

const getOffersPublicSessionProgress = async (roundId) => {
    return await RestRequestGET(Endpoints.RFX_OFFERS_PUBLIC_SESSION_PROGRESS(roundId));
}

const startOffersPublicSessionProcess = async (roundId) => {
    return await RestRequestPOST(Endpoints.RFX_OFFERS_PUBLIC_SESSION_START(roundId));
}

const getOffersPublicSessionOnlineStatus = async (roundId) => {
    const resp = await RestRequestGET(Endpoints.RFX_OFFERS_PUBLIC_SESSION_ONLINE_STATUS(roundId));
    reduxStore.dispatch(setResource(RESOURCE_ID_RFX_PUBLIC_SESSION_ONLINE_STATUS, resp));
}

const saveOffersPublicSessionOnline = async (roundId, values) => {
    return await RestRequestPOST(Endpoints.RFX_OFFERS_PUBLIC_SESSION_ONLINE_SAVE(roundId), values);
}

const downloadOffersAttachments = async (roundId, finallyCallback = () => {
}) => {
    try {
        RestRequestBLOB(Endpoints.RFX_OFFERS_ATTACHMENTS(roundId))
            .finally(finallyCallback);
    } catch (error) {
    }
}

const verifyOffersAttachments = async (roundId, finallyCallback = () => {
}) => {
    try {
        RestRequestBLOB(Endpoints.RFX_OFFERS_VERIFY_ATTACHMENTS(roundId), undefined, 'post')
            .finally(finallyCallback);
    } catch (error) {
    }
}
const downloadOffersSummary = async (roundId, type, finallyCallback = () => {
}) => {
    try {
        RestRequestBLOB(Endpoints.RFX_OFFERS_SUMMARY(roundId, type))
            .finally(finallyCallback);
    } catch (error) {
    }
}
const saveEnvelope = async (roundId, envelope) => {
        return await RestRequestPOST(Endpoints.RFX_OFFERS_ENVELOPE(roundId), envelope);
}
const getEnvelope = async (roundId, envelopeId) => {
        return await RestRequestGET(Endpoints.RFX_OFFERS_ENVELOPE_ID(roundId, envelopeId));
}


export default {
    getOffers,
    sendIvniteToOffers,
    clearResources,
    getOffersDecryptionStatus,
    getOffersDecryptionProgress,
    startOffersDecryptionProcess,
    getOffersPublicSessionStatus,
    getOffersPublicSessionProgress,
    startOffersPublicSessionProcess,
    getOffersPublicSessionOnlineStatus,
    saveOffersPublicSessionOnline,
    downloadOffersAttachments,
    verifyOffersAttachments,
    downloadOffersSummary,
    saveEnvelope,
    getEnvelope,
    getAvailableActions,
    getAdditionalRoundsOffers,
    clearAdditionalRoundsOffers,
    RESOURCE_ID_RFX_OFFER_LIST,
    RESOURCE_ID_RFX_OFFER_DECRYPTION_STATUS,
    RESOURCE_ID_RFX_OFFER_PUBLIC_SESSION_STATUS,
    RESOURCE_ID_RFX_PUBLIC_SESSION_ONLINE_STATUS,
    RESOURCE_ID_RFX_OFFERS_ACTIONS
}